import { query, mutation } from "../../api";
import axios from "axios";

export async function updateSignApplication(reqObj) {
  try {
    let basicProfile =  await mutation(
      "update_signup_application",
      reqObj,
      `_id
        status
        message
        fullName
        lastName
        businessName
        emailAddress
        gender
        pan
        martialStatus
        residentialStatus
        permanentAddress
        communicationAddress
        fathersName
        mothersName
        otherOccupation
        occupationType
        annualIncome
        isPoliticalyExposed
        same_address
        trust_sms
        annual_report_despatch_mode
        rta_email_share
        transaction_alerts_preference
        referralCode
        is_joint_account
        joint_holder_second_fullname
        joint_holder_second_mobile
        joint_holder_second_sign
        joint_holder_third_fullname
        joint_holder_third_mobile
        joint_holder_third_sign
        nominee_consent
        option_form_issue_dis_booklet_option2
        nominees {
          nominee_number
          name
          percentage_of_share
          relationship
          address
          mobile
          email
          id_type
          id_number
          dob_if_minor
          minor_guardian_info {
            guardian_name
            guardian_address
            guardian_mobile
            guardian_email
            guardian_relationship
            guardian_id_type
            guardian_id_number
          }
        }`
    );

    return basicProfile;
    
  } catch (e) {
    console.log(e);
  }
}

export async function fetchSignApplication(){
    return mutation("fetch_signup_application", {}, `_id
    status
    message
    user_id
    fullName
    firstName
    lastName
    businessName
    emailAddress
    gender
    dob
    pan
    martialStatus
    residentialStatus
    permanentAddress
    communicationAddress
    fathersName
    mothersName
    otherOccupation
    occupationType
    annualIncome
    isPoliticalyExposed
    same_address
    pan_front
    cheque_image
    signature_image
    profile_image
    razorpay_order_id
    account_number
    ifsc
    account_type
    net_worth
    net_worth_date
    trust_sms
    annual_report_despatch_mode
    rta_email_share
    transaction_alerts_preference
    referralCode
    is_joint_account
    joint_holder_second_fullname
    joint_holder_second_mobile
    joint_holder_second_sign
    joint_holder_third_fullname
    joint_holder_third_mobile
    joint_holder_third_sign
    nominee_consent
    option_form_issue_dis_booklet_option2
    nominees {
      nominee_number
      name
      percentage_of_share
      relationship
      address
      mobile
      email
      id_type
      id_number
      dob_if_minor
      minor_guardian_info {
        guardian_name
        guardian_address
        guardian_mobile
        guardian_email
        guardian_relationship
        guardian_id_type
        guardian_id_number
      }
    }`
  );
}


export async function sendEmail(reqObj) {
  return mutation(
    "send_email",
    {
      to: reqObj.emailAddress
    },
    "status",
    "email"
  );
}

export async function verifyEmail(email, otp) {
  return mutation(
    "verify_email",
    {
      email_id: email, otp
    },
    `status
    message`,"email"
  );
}


export async function getIfscCode(ifscCode) {
  try {    
    let url= 'https://ifsc.razorpay.com/'+ifscCode;
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.error(err);
    throw err;
  }
}